import { render, staticRenderFns } from "./buy-form.vue?vue&type=template&id=a6483a8e&scoped=true"
import script from "./buy-form.vue?vue&type=script&lang=js"
export * from "./buy-form.vue?vue&type=script&lang=js"
import style0 from "./buy-form.vue?vue&type=style&index=0&id=a6483a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6483a8e",
  null
  
)

export default component.exports